export const isMobile = "@media (max-width: 830px)";
